import {
  createEntityAdapter,
  createSlice,
  DeepPartial,
  PayloadAction,
} from '@reduxjs/toolkit';

import { Organization } from 'protocol/model/dto_organization_pb';

import { SliceName } from '@/shared/config';

export const organizationsAdapter = createEntityAdapter<
  DeepPartial<Organization>
>({
  selectId: (organization) => organization.ID,
});

const initialState = {
  loading: false,
};

const organizationsSlice = createSlice({
  name: SliceName.organizations,
  initialState: organizationsAdapter.getInitialState(initialState),
  reducers: {
    addOne: organizationsAdapter.addOne,
    addMany: organizationsAdapter.addMany,
    setOne: organizationsAdapter.setOne,
    setMany: organizationsAdapter.setMany,
    removeAll: organizationsAdapter.removeAll,
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
  },
});

export const { actions } = organizationsSlice;

export default organizationsSlice.reducer;
